<template>
  <div>
    <Breadcrumbs />
    <div class="wrapper mt-5 mb-5 pb-5">
      <div class="container checkout-container">
        <form action="#" method="POST">
          <div class="row justify-content-center g-5">
            <CheckoutAddress ref="address" />
            <CheckoutPayment />
            <CheckoutOverview />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs.vue";
import CheckoutAddress from "@/esf_antarctica_lederhosenland/core/components/checkout/CheckoutAddress.vue";
import CheckoutPayment from "@/esf_antarctica_lederhosenland/core/components/checkout/CheckoutPayment.vue";
import CheckoutOverview from "@/esf_antarctica_lederhosenland/core/components/checkout/CheckoutOverview.vue";

export default {
  name: "CheckoutPage",
  components: {
    Breadcrumbs,
    CheckoutAddress,
    CheckoutPayment,
    CheckoutOverview,
  },
  metaInfo() {
    return {
      title: "Checkout",
      // all titles will be injected into this template
    };
  },
  methods: {
    clearLocalStorage() {
      localStorage.removeItem("checkoutAddress");
      localStorage.removeItem("checkoutPayment");
      localStorage.removeItem("checkoutOverview");
    },
  },

  mounted() {
    const bcrumb = { current: "Checkout", routes: [] };
    this.$store.commit("breadcrumbs/set", bcrumb);
    this.$root.$on("clearLocalStorage", () => {
      this.clearLocalStorage();
    });
  },
};
</script>

<style lang="scss">
</style>
